<template>
  <div class="supply">
    
    
    <div class="hard">
      <div class="big-title">
        <p>行业现状</p>
        <div class="line"></div>
        <div class="desc">
          如何加强施工现场安全管理、降低事故发生频率、杜绝各种违规操作和不文明施工、提高建筑工程质量
        </div>
      </div>
      <div class="hard-box">
        <div class="hard-item" v-for="item in hardArr" :key="item.id">
          <img :src="item.img" alt="" />
        </div>
      </div>
    </div>


    <div class="system">
      <div class="big-title">
        <p>核心功能</p>
        <div class="line"></div>
        <div class="desc">
          围绕施工现场管理，运用先进的技术，构建全方位的智能监控防范体系弥补传统方法和技术在监管中的缺陷<br/>形成安全、质量、进度、人员、机械、绿色施工六大针对性解决方案。
        </div>
      </div>
      <div class="manageBox">
        <div class="manage_left_box">
          <div class="manage_left_img">
            <img src="../../static/images/solution/workSite6.png" alt="" />
            <img src="../../static/images/solution/workSite5.png" alt="" />
          </div>
          <h5>安全管理</h5>
          <p>实时跟踪安全专项教育落实情况<br/>实现工程施工过程全监控<br/>风险问题及时发现、快速沟通、应急处理<br/>远程调度，通过本质安全、过程安全、监测安全<br/>保障安全目标的最终落地。</p>
        </div>
        <div class="manage_right_box">
          <div class="manage_list">
            <h4>
              痛点：
            </h4>
            <p>施工现场涉及面广，多种元素交叉，状况较为复杂，人员出入、机械运行、物料运输等 工程项目管理在一定程度上存在着决策层看不清、管理层管不住、执行层做不好的问题，信息难掌握不及时，管理不到位，事故隐患易发。</p>
          </div>

           <div class="manage_list">
            <h4>
              安全管理解决方案：
            </h4>
            <p> 是从危险源辨识开始到危险源消失或控制结束，从方案设计到施工完成的全过程管理，通过本质安全、过程安全、监测安全，保障安全目标的最终落地。</p>
          </div>

          <h6><span>施工安全：</span> 加强施工过程监管，消除工程施工过程中存在的安全隐患，确保施工安全。</h6>
          <h6><span>人员安全：</span> 实时监控管理，危险预警，保障施工人员的人身安全。</h6>
          <h6><span>数据安全：</span> 管理员认证系统，保障主管部门数据安全，杜绝信息外泄。</h6>
          <h6><span>机械安全：</span> G4监控仪实时监管，第一视角实时查看现场环境，异常告警，减少工程事故的发生。</h6>
          <h6><span>配套智能硬件</span> </h6>

        </div>
      </div>
      <div class="system-box">
        <div class="system-item" v-for="item in systemArr" :key="item.id" >
          <img :src="item.img" alt="" />
          <div>
              <h5>{{ item.title }}</h5>
              <h6>{{ item.desc }}</h6>
          </div>
        </div>
      </div>
    </div>

    <div class="modeValue">
      <div class="big-title">
        <p>核心价值</p>
        <div class="line"></div>
        <div class="desc">
          通过采集、集成和应用建筑施工数据，实现对于施工现场的信息化监管
        </div>
      </div>
      <div class="modeCont">
        <img src="../../static/images/solution/workSite12.png" alt="" />
        <div class="modeContText">
          <div class="modeItro">
            <h4>工地数字化</h4>
            <p>将施工现场的施工过程、安全管理、人员管理、绿色施工等重点环节，通过智能硬件进行实时采集，实现工地业务数字化。</p>
            
          </div>
          <div class="modeItro">
            <h4>数据网络化</h4>
            <p>智慧工地建设是一个数据高度集成的过程，以采集前端子系统的数据为基础，集成各个子系统的应用，最终在云平台上完成集成，并通过互联网进行便捷访问。</p>
          </div>
          <div class="modeItro">
            <h4>管理智慧化</h4>
            <p>平台及终端聚合了先进的计算机智能判断和分析策略，有效帮助管理者聚焦关键问题，主动规避风险，优化执行操作，从而将管理水平上升到一个新的智慧境界。</p>
          </div>
          <!-- <h6  @click="jumpService">了解详情</h6> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //核心列表
      hardArr: [
        {
          id: 0,
          img: require("../../static/images/solution/workSite1.png"),
        },
        {
          id: 1,
          img: require("../../static/images/solution/workSite2.png"),
        },
        {
          id: 2,
          img: require("../../static/images/solution/workSite3.png"),
        },
        {
          id: 3,
          img: require("../../static/images/solution/workSite4.png"),
        },
      ],
      //行业痛点数据
      systemArr: [
        {
          id: 0,
          title:'质量管理',
          desc: "从结构安全的主材、养护、检测切入，关注过程管理和质量验收，提供可追溯、可检测、可量化的质量管控措施。",
          img: require("../../static/images/solution/workSite7.png"),
        },
        {
          id: 1,
          title:'进度管理',
          desc: "人员管理从建筑工人的入场规范管理开始，到薪酬结算离场结束，以数字化、智能化的技术支撑，关注人员行为、安全、工效和健康，保证施工过程的正常和有序。",
          img: require("../../static/images/solution/workSite8.png"),
        },
        {
          id: 2,
          title:'人员管理',
          desc: "人员管理从建筑工人的入场规范管理开始，到薪酬结算离场结束，以数字化、智能化的技术支撑，关注人员行为、安全、工效和健康，保证施工过程的正常和有序。",
          img: require("../../static/images/solution/workSite9.png"),
        },
        {
          id: 3,
          title:'机械管理',
          desc: "从大型起重机械设备的司机操作许可管理到驾驶过程设备状态监测，以终端感知和云端分析为主要手段，提供分析、报警、记录、异常终止等功能，聚焦设备安全、环境安全和操作安全，将机械管理规范落。",
          img: require("../../static/images/solution/workSite10.png"),
        },
        {
          id: 4,
          title:'绿色施工',
          desc: "从扬尘监测到降尘控制，从过程无记录到自动计量，从节水循环到预警提醒，绿色施工通过体系化的数字设计，对绿色施工的各个环节进行全面的自动化控制，确保自然、绿色的理念贯彻在工地的每一处。",
          img: require("../../static/images/solution/workSite11.png"),
        },
      ],
      modeIndex:0,//选中的模式
      //模式列表
      modeList:[
        {
          img:require("../../static/images/solution/mode1.png"),
          title:'多商城系统自营模式',
          cont:'企业平台建立线上B2B2C商城系统，整合多种自身渠道业务。通过会员、商品、订单、账务和仓储管理系统，对B2B2C商城线上线下多种渠道进行统一管理',
        },{
          img:require("../../static/images/solution/mode3.png"),
          title:'多用户商城联营模式',
          cont:'多个渠道供应商一起合作经营，以商品入库、统一仓储、统一物流的方式进入库联营。多用户商城平台企业通过供销或直销的方式，将供应商资源纳入多用户商城平台自营体系，建立多个自营店铺，多样化商品和服务种类，进行资源整合。',
        },{
          img:require("../../static/images/solution/mode4.png"),
          title:'多店商城招商模式',
          cont:'多店铺商城系统企业签约多个渠道供应商，通过会员、交易、平台和财务管理系统，对多店商城网站进行管理，多个渠道供应商，以签约加盟的方式，入驻B2B2C商城平台',
        },{
          img:require("../../static/images/solution/mode2.png"),
          title:'多用户购物商城自营+招商模式',
          cont:'B2B2C系统企业整合多个渠道业务，通过会员、商品、订单、财务和仓储管理系统，入驻商家可自行对商品订单等进行管理，定期与多用户商城平台进行账务结算',
        },
      ],
    };
    },
    methods:{
      //立即咨询
    jumpService() {
      this.$addConsult()
    },
  },
};
</script>

<style lang="stylus" scoped>
.supply {
  margin: 80px 0 80px;
}

.hard {
  width: 100%;
  text-align :center
  margin: 0 auto;
  padding-bottom: 80px;
  .hard-box {
    display: flex;
    justify-content :space-between;
    margin:0 auto ;
    width :1400px;
  }

  .hard-item {
    box-sizing: border-box;
    width :332px;
    height :360px;
    background: #352E2C;
    border-radius: 8px;
    img{
      width :332px;
      height :360px;
    }

  }
}

 .modeValue {
  width: 1400px;
  margin: 81px auto;
}
.modeCont{
  display :flex;
  justify-content :center
  margin:27px;
  img{
    width :484px;
    height :360px;
  }
  .modeContText{
    text-align :left;
    margin :38px 0 0 98px
  }
}
.modeItro{
  margin :30px 0 0 0;
    h4{
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
    }
    h4:before{
      content :''
      width: 1px;
      height: 20px;
      background: #FFC000;
      border: 2px solid #FFC000;
      margin:0 12px 0 0
    }
    p{
      font-size: 16px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      margin :10px 0 0 15px;
    }
}

.system {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;

  .manageBox{
    width: 1400px;
    display :flex;
    height: 445px;
    background: #FFFFFF;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    border-radius: 8px;
    margin:0 0 24px 0 
  }
  .manage_left_box{
    width: 546px;
    height :100%;
    background: #FFC000;
    border-radius: 8px 0px 0px 8px;
    padding :0 48px
    .manage_left_img{
      display :flex;
      justify-content :space-between;
      padding:48px 0 49px 0;
      img:first-child{
        width :58px;
        height :58px
      }
      img:last-child{
        width :94px;
        height :70px
      }
    }
    h5{
      font-size: 24px;
      font-weight: bold;
      color: #666666;
      line-height: 24px;
      margin :0 0 20px 0
    }
    p{
      font-size: 16px;
      font-weight: 400;
      color: #666666;
      line-height: 30px;
    }
  }
  .manage_right_box{
    width :855px;
    padding:46px;
    .manage_list{
        line-height: 24px;
        color: #666666;
      h4{
        font-size: 18px;
        font-weight: bold;
      }
      p{
        font-size: 14px;
        font-weight: 400;
        margin :15px 0 39px 0;
      }
    }
    h6{
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
      span{
        font-size: 14px;
        font-weight: bold;
        padding : 0 16px 0 0
      }

    }
  }
  .system-box {
    display: flex;
    flex-wrap: wrap;
    justify-content :space-between
  }

  .system-item {
    width: 262px;
    height: 377px;
    padding :31px 23px;
    background: #FFFFFF;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    border-radius: 4px;
    text-align :center
    img{
      width :58px;
      height :58px
      margin:0 0 30px 0 
    }

    h5{
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      margin :0 0 20px 0
    }
    h6{
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
    }
  }

  .system-item:hover {
    box-shadow: 0px 5px 17px 3px rgba(230, 192, 76, 0.15);
  }
}

 .line {
    width: 42px;
    height: 2px;
    background: #FFC000;
    border-radius: 1px;
    margin-top: 29px;
  }
.big-title {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
  }

 

  .desc {
    font-size: 16px;
    font-weight: 400;
    color: #333;
    text-align: center;
    margin: 22px 0 50px;
    line-height: 28px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/solutionWorkSite.vue